const decimalUpToSeven = (x: number) => Number(x.toFixed(7));
export default decimalUpToSeven;
